import React, { useState, useContext } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./signup.css";
import NavBarAuth from "../../../../components/navbar/navbarAuth";
import { Link, useNavigate } from "react-router-dom";
import { BaseURL } from "../../../../Files/BaseURL";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function SignUpForm() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;
  const navigate = useNavigate();

  const [errors, setErrors] = useState({
    phone: "",
    password: "",
  });

  const validatePhone = (phone) => {
    if (!phone) {
      return "Phone number is required";
    }
    if (phone.length < 10) {
      return "Please enter a valid phone number";
    }
    return "";
  };

  const validatePassword = (password) => {
    const errors = [];
    if (password.length < 8) {
      errors.push("Password must be at least 8 characters long");
    }
    if (password.length > 30) {
      errors.push("Password must not exceed 30 characters");
    }
    if (!/[A-Z]/.test(password)) {
      errors.push("Password must contain at least one uppercase letter");
    }
    if (!/[a-z]/.test(password)) {
      errors.push("Password must contain at least one lowercase letter");
    }
    if (!/[0-9]/.test(password)) {
      errors.push("Password must contain at least one number");
    }
    if (!/[!@#$%^&*]/.test(password)) {
      errors.push("Password must contain at least one special character (!@#$%^&*)");
    }
    return errors;
  };

  // const checkPasswordRequirement = (password, requirement) => {
  //   switch (requirement) {
  //     case "At least 8 characters long":
  //       return password.length >= 8;
  //     case "Maximum 30 characters":
  //       return password.length <= 30;
  //     case "At least one uppercase letter":
  //       return /[A-Z]/.test(password);
  //     case "At least one lowercase letter":
  //       return /[a-z]/.test(password);
  //     case "At least one number":
  //       return /[0-9]/.test(password);
  //     case "At least one special character (!@#$%^&*)":
  //       return /[!@#$%^&*]/.test(password);
  //     default:
  //       return false;
  //   }
  // };

  // const passwordRequirements = [
  //   "At least 8 characters long",
  //   "Maximum 30 characters",
  //   "At least one uppercase letter",
  //   "At least one lowercase letter",
  //   "At least one number",
  //   "At least one special character (!@#$%^&*)"
  // ];

  const handleLogin = async () => {
    const phoneError = validatePhone(phone);
    const passwordErrors = validatePassword(password);

    setErrors({
      phone: phoneError,
      password: passwordErrors.length > 0 ? passwordErrors[0] : "",
    });

    if (phoneError || passwordErrors.length > 0) {
      return;
    }

    try {
      const response = await fetch(
        `${BaseURL}/api/authlogin/loginmobilenumber`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ Phone: phone, Password: password }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        sessionStorage.setItem("signtoken", data.AuthToken);
        sessionStorage.setItem("loginPhone", phone);
        navigate(`/verify-otp`, {
          state: {
            name: "phone",
            showLoginSuccess: true,
          },
        });
      } else {
        showAlert(data.Message, "danger");
      }
    } catch (error) {
      showAlert("Error logging in", "danger");
    }
  };

  return (
    <>
      <NavBarAuth />
      <div className="flex justify-center items-center bg-gray-100 py-20">
        <div className="mx-6 bg-white p-8 rounded-lg shadow-md">
          <h2 className="text-2xl font-pop font-bold mb-8">
            Welcome to Paycott.
          </h2>
          <p className="text-gray-600 font-pop mb-10 max-w-sm">
            To login to your Paycott account we need the mobile number
            registered on your account
          </p>
          <div className="mb-4">
            <PhoneInput
              name="phoneNumber"
              type="text"
              country={"us"}
              enableAreaCodes={true}
              areaCodes={{ us: ["332"] }}
              inputProps={{
                name: "phone",
                country: "us",
                required: true,
                autoFocus: true,
              }}
              containerClass={`rounded-full ${
                errors.phone ? "border-2 border-red-500" : ""
              }`}
              className="rounded-full"
              inputClass={`w-full px-6 border-2 ${
                errors.phone ? "border-red-500" : "border-transparent"
              } font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-green-500 focus:outline-none`}
              buttonStyle={{
                borderTopLeftRadius: "9999px",
                borderBottomLeftRadius: "9999px",
              }}
              inputStyle={{
                width: "100%",
                borderRadius: "9999px",
              }}
              value={phone}
              onChange={(phone) => {
                setPhone(phone);
                setErrors((prev) => ({ ...prev, phone: "" }));
              }}
              required
            />
            {errors.phone && (
              <p className="text-red-500 text-sm mt-1 ml-4">{errors.phone}</p>
            )}
          </div>

          <div className="mb-4 relative">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              placeholder="Password"
              className={`w-full px-6 border-2 ${
                errors.password ? "border-red-500" : "border-transparent"
              } font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none`}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setErrors((prev) => ({ ...prev, password: "" }));
              }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-4 top-6 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
            >
              {showPassword ? <FaEyeSlash size={15} /> : <FaEye size={15} />}
            </button>
            {errors.password && (
              <p className="text-red-500 text-sm mt-1 ml-4">{errors.password}</p>
            )}
          </div>

          {/* <div className="mb-4 bg-gray-50 p-4 rounded-lg">
            <h3 className="text-sm font-semibold mb-2">Password Requirements:</h3>
            <ul className="text-sm text-gray-600 space-y-1">
              {passwordRequirements.map((requirement, index) => (
                <li key={index} className="flex items-center">
                  <span className={`mr-2 ${checkPasswordRequirement(password, requirement) ? 'text-green-500' : 'text-gray-400'}`}>
                    {checkPasswordRequirement(password, requirement) ? '✓' : '○'}
                  </span>
                  {requirement}
                </li>
              ))}
            </ul>
          </div> */}

          <div className="flex justify-between">
            <Link
              to="/signinemail"
              className="mb-4 font-pop text-green-500 cursor-pointer hover:text-green-700"
            >
              Login via email
            </Link>
            <Link to="/forgot_password" className="font-pop text-sm font-semibold  text-red-500 hover:text-red-400 cursor-pointer mb-4">
              Forgot password
            </Link>
          </div>
          <button
            onClick={handleLogin}
            className="my-4 w-full bg-green-500 hover:bg-transparent hover:bg-white-500 font-semibold hover:text-black font-pop text-xl py-3 px-4 border border-black-500 hover:border-green-500 rounded-full text-white animate__animated animate__backInUp"
          >
            Next
          </button>
          <p className="my-2 font-pop text-center">
            New user? Create account{" "}
            <span className="text-primarygreen font-medium">
              <Link to={"/signup"}>here</Link>{" "}
            </span>
          </p>
        </div>
      </div>
    </>
  );
}

export default SignUpForm;
